import { ValidationContext } from "../../../../../common/validation/validationContext";
import { ValidationErrorLevels } from "../../../../../common/validation/ValidationErrorLevels";
import { ValidationScopes } from "../../../../../common/validation/ValidationScopes";
import { ForkalkylsmallDTO } from "../../models/ForkalkylsmallDTO";

export class SkapaMallFranHandelssortimentValidation {
    static init(mall: ForkalkylsmallDTO, existingNames: string[]): ValidationContext {
        const context = new ValidationContext();
        // Fuling? Får inte till det annars.
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 1,
                expression: () => !(mall.namn === null || mall.namn === undefined || mall.namn.length === 0),
                message: { text: "Fält kan inte vara tomt" },
                model: () => mall.namn,
                name: "namnRequired"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 2,
                expression: () => (!!existingNames && !existingNames.some(x => x.trim().toLowerCase() === mall.namn.trim().toLowerCase())),
                message: { text: "Namnet är upptaget" },
                model: () => mall.namn,
                name: "namnAlreadyTaken"
            }
        ]);
        return context;
    }
}
